<template>
  <div class="ee-card-attribute datetime">
    <r-text type="caption" style="margin-bottom: 8px;">
      {{ config.label }}
    </r-text>
    <el-date-picker
      class="r-date-picker"
      size="mini"
      v-model="feature[config.prop]"
      format="dd.MM.yyyy HH:mm"
      value-format="yyyy-MM-ddTHH:mm:ss+03:00"
      type="datetime"
      align="right"
      placeholder="Выберите дату и время"
    />
  </div>
</template>

<script>
export default {
  props: ["feature", "config"]
};
</script>

<style lang="scss">
.ee-card-attribute.datetime {
  .el-date-editor {
    width: 100%;
  }
}
</style>
